var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6502_37105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7109 30.2375C20.505 30.2375 20.3075 30.1557 20.1618 30.01C20.0162 29.8644 19.9344 29.6669 19.9344 29.4609V11.4141C19.9344 11.2081 20.0162 11.0106 20.1618 10.8649C20.3075 10.7193 20.505 10.6375 20.7109 10.6375C20.9169 10.6375 21.1144 10.7193 21.2601 10.8649C21.4057 11.0106 21.4875 11.2081 21.4875 11.4141V29.4609C21.4875 29.6669 21.4057 29.8644 21.26 30.0101C21.1144 30.1557 20.9169 30.2375 20.7109 30.2375Z",
    fill: "#146C94",
    stroke: "#146C94",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7344 21.4141H11.6875C11.4285 21.4141 11.1801 21.3112 10.997 21.128C10.8138 20.9449 10.7109 20.6965 10.7109 20.4375C10.7109 20.1785 10.8138 19.9301 10.997 19.747C11.1801 19.5638 11.4285 19.4609 11.6875 19.4609H29.7344C29.9934 19.4609 30.2418 19.5638 30.4249 19.747C30.608 19.9301 30.7109 20.1785 30.7109 20.4375C30.7109 20.6965 30.608 20.9449 30.4249 21.128C30.2418 21.3112 29.9934 21.4141 29.7344 21.4141Z",
    fill: "#146C94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6502_37105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10.7109 10.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusblue);
export default __webpack_public_path__ + "static/media/plusblue.35e273542ceec6dd6a5c6d058bdaa7ea.svg";
export { ForwardRef as ReactComponent };